<template>
  <div v-if="visible" class="bimplusfilter viewer-model-filter">
    <header class="bimplusfilter-head">
      <div class="column">
        <div class="columns">
          <div class="column is-flex is-align-items-center">
            <i class="icon-modelsettings has-text-black-bis"></i>
             <div class="is-divider-vertical my-0"></div>
              <h3 class="is-italic has-text-weight-semibold has-text-black-bis">
                BIMPLUS MODEL SETTINGS
              </h3>
          </div>
          <div class="column  is-flex is-narrow is-align-items-center">
            <i class="icon-addnew has-text-black-bis"></i>
            <div class="is-divider-vertical my-0"></div>
            <i class="icon-close has-text-black-bis pointer" @click="$emit('close')"></i>
          </div>
        </div>
      </div>  
    </header>
    <div class="bimplusfilter-body is-visible has-background-white">
     <div class="column">
      <div class="columns">
        <div class="column is-italic has-text-weight-semibold has-text-dark">
          <h3 class="is-size-3">GROUPING PROPERTIES</h3>
          <span class="mr-3">Property 1:</span><span >Order</span>
        </div>
        <div class="column is-italic has-text-weight-semibold has-text-dark">
          <h3 class="is-italic has-text-weight-semibold has-text-dark">PROPERTY ASSOCIATIONS</h3>
          <span class="mr-3">Catalog Id:</span><span >Doors</span>
        </div>
      </div>
     </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ModelSettings',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>